module.exports = __webpack_public_path__ + "img/eg-7-01.4ea6ab25.jpg";